module.exports = __webpack_public_path__ + "static/img/kaishihuiyi.b805151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/kaishihuiyi.png
// module id = N20H
// module chunks = 24